module.exports = __webpack_public_path__ + "static/media/progman_23.dc6b9e35.ico";